import { render, staticRenderFns } from "./VCode.vue?vue&type=template&id=45c0844c&scoped=true&"
import script from "./VCode.vue?vue&type=script&lang=js&"
export * from "./VCode.vue?vue&type=script&lang=js&"
import style0 from "./VCode.vue?vue&type=style&index=0&id=45c0844c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c0844c",
  null
  
)

export default component.exports